<template>
  <v-container fluid>
    <v-card flat>
      <!-- タイトル -->
      <v-card-title
        v-if="mode === 'regist'"
        class="mt-3 pb-5 text-h5 font-weight-bold"
      >
        {{ wordList.lbl_regular_delivery_Request_regist }}
      </v-card-title>
      <v-card-title
        v-if="mode === 'list'"
        class="mt-3 pb-5 text-h5 font-weight-bold"
      >
        {{ wordList.lbl_regular_delivery_Request_list }}
      </v-card-title>
    </v-card>
    <!-- タブ設定 -->
    <v-tabs v-model="model" hide-slider>
      <div class="tab_switch d-flex align-center">
        <v-tab
          :class="[model === 0 ? 'tab_switch_active' : 'tab_switch_inactive', 'd-flex align-center justify-center rounded-pill']"
          @click="onClickRegistTab"
        >
          {{ wordList.lbl_regist }}
        </v-tab>
        <v-tab
          :class="[model === 1 ? 'tab_switch_active' : 'tab_switch_inactive', 'ml-2 d-flex align-center justify-center rounded-pill']"
          @click="onClickListTab"
        >
          {{ wordList.lbl_list }}
        </v-tab>
      </div>
    </v-tabs>
    <!-- 定期配送登録タブ -->
    <v-tabs-window v-model="model" v-if="isWordListReady">
      <v-tabs-window-item :value="0">
        <v-card flat>
            <v-card-text>
              <v-container fluid>
                <!-- アクションメニュー -->
                <v-row class="row_eq_height">
                  <!-- 新規会員 -->
                  <v-col>
                    <v-card height="100%" flat border class="mx-auto">
                    <v-card-title class="d-flex justify-center mb-4">
                      {{ wordList.lbl_first_time_member }}
                    </v-card-title>
                      <v-card-text>
                        <v-row class="justify-center">
                          <v-btn-toggle
                            :model-value="btnNonMemberToggle"
                            rounded
                            density="compact"
                            color="#2196F3"
                            class="pt-2"
                            selected-class="bg-primary text-white border-primary"
                          >
                            <!-- 郵便番号 -->
                            <v-btn
                              :value="0"
                              class="pl-10 pr-10"
                              variant="outlined"
                              color="grey-lighten-1"
                              @click="onClickToggleZip"
                              >{{ wordList.lbl_zipcode }}</v-btn
                            >
                            <!-- 都道府県 -->
                            <v-btn
                              :value="1"
                              class="pl-10 pr-10"
                              variant="outlined"
                              color="grey-lighten-1"
                              @click="onClickTogglePref"
                              >{{ wordList.lbl_prefectures }}</v-btn
                            >
                          </v-btn-toggle>
                        </v-row>
                        <v-row v-if="btnNonMemberToggle == 0">
                          <v-col align-self="center">
                            <!-- 郵便番号 -->
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="zip_code"
                              :name="wordList['lbl_zipcode']"
                              rules="required|numeric|length:7"
                              @update:model-value="onZipCodeInput"
                            >
                              <v-text-field
                                v-bind="componentField"
                                class="mx-auto"
                                :placeholder="wordList.plc_zipcode"
                                density="compact"
                                variant="outlined"
                                :hint="wordList.lbl_no_hyphen"
                                persistent-hint
                                :error-messages="errors"
                                style="width: 80%"
                              ></v-text-field>
                            </Field>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="errorZipCode && btnNonMemberToggle == 0"
                          dense
                        >
                          <v-col>
                            <v-card-text
                              class="text-red px-0 py-0 mx-auto"
                              style="width: 80%"
                            >
                              {{ errorZipCode }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                        <v-row v-if="btnNonMemberToggle == 1">
                          <v-col align-self="center">
                            <!-- 都道府県 -->
                            <v-autocomplete
                              v-model="prefSelectValue"
                              class="mx-auto"
                              density="compact"
                              :items="prefListItems"
                              item-title="name"
                              item-value="pref_name"
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              style="width: 80%"
                              @update:model-value="onPrefSelectInput"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="errorPrefSelect && btnNonMemberToggle == 1"
                          dense
                        >
                          <v-col>
                            <v-card-text
                              class="text-red px-0 py-0 mx-auto"
                              style="width: 80%"
                            >
                              {{ errorPrefSelect }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions class="justify-center pb-8">
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mb-3"
                          :disabled="btnDisabled"
                          @click="onClickDeliveryRequestAndNewMember"
                        >
                          <v-icon>mdi-playlist-edit</v-icon>
                          {{ wordList.btn_delivery_regits_member }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <!-- 既存会員 -->
                  <v-col>
                    <v-card flat border class="mx-auto">
                    <v-card-title class="d-flex justify-center mb-4">
                      {{ wordList.lbl_registered_member }}
                    </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col class="pb-2" align-self="center">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="phone_number"
                              :name="wordList.lbl_tel4"
                              rules="numeric|length:4"
                            >
                              <v-text-field
                                v-bind="componentField"
                                class="mx-auto"
                                :label="wordList.lbl_tel4"
                                variant="outlined"
                                density="compact"
                                persistent-placeholder
                                :placeholder="wordList.lbl_tel4"
                                :error-messages="errors"
                                style="width: 80%"
                              ></v-text-field>
                            </Field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0" align-self="center">
                            <v-text-field
                              v-model="user_name"
                              class="mx-auto"
                              :label="wordList.lbl_name_kana"
                              variant="outlined"
                              density="compact"
                              persistent-placeholder
                              :placeholder="wordList.plc_name"
                              style="width: 80%"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="house_card_display == 1">
                          <v-col class="py-0" align-self="center">
                            <v-text-field
                              v-model="house_card"
                              class="mx-auto"
                              :label="wordList.lbl_house_card"
                              variant="outlined"
                              density="compact"
                              persistent-placeholder
                              :placeholder="wordList.plc_house_card"
                              style="width: 80%"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="userErrorMessage" dense>
                          <v-col class="py-0">
                            <v-card-text
                              class="text-red px-0 py-0 mx-auto"
                              style="width: 80%"
                            >
                              {{ userErrorMessage }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions class="justify-center">
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mb-3"
                          :disabled="btnDisabled"
                          @click="onClickDeliveryRequest"
                        >
                          <v-icon>mdi-magnify</v-icon>
                          {{ wordList.btn_delivery_regist }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- 会員登録情報確認ダイアログ {-->
            <v-dialog v-model="dialog" width="80%" scrollable>
              <v-data-iterator
                :items="listMemberResult"
                item-key="name"
                hide-default-footer
                :items-per-page="-1"
                :server-items-length="50"
              >
                <template #default="{ items }">
                  <v-card>
                    <v-card-title
                      class="bg-primary mb-5"
                      style="color: white"
                      >{{ wordList.lbl_member_confirm }}</v-card-title
                    >
                    <v-card-text class="font-weight-black"
                      >{{ wordList.lbl_hit_member_info }}
                      {{ listMemberResult.length }}
                      {{ wordList.lbl_exist_number }}</v-card-text
                    >
                    <v-card-text class="overflow-y-auto" style="max-height: 60vh">
                      <v-card
                        v-for="item in items"
                        :key="item.raw?.member_id"
                        class="mb-5"
                      >
                        <v-card-title class="py-2">
                          <h5>
                            {{ wordList.lbl_member_id }} : {{ item.raw?.member_id }}
                          </h5>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-row dense>
                            <v-col
                              cols="5"
                              sm="2"
                              md="2"
                              lg="2"
                              class="font-weight-black"
                              >{{ wordList.lbl_member_id }} :
                            </v-col>
                            <v-col>
                              {{ item.raw?.member_id }}
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col
                              cols="5"
                              sm="2"
                              md="2"
                              lg="2"
                              class="font-weight-black"
                              >{{ wordList.lbl_name }} :
                            </v-col>
                            <v-col>
                              {{ item.raw?.name_kana1 }} {{ item.raw?.name_kana2 }}
                              {{ wordList.lbl_sama }}
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col
                              cols="5"
                              sm="2"
                              md="2"
                              lg="2"
                              class="font-weight-black"
                              >{{ wordList.lbl_tel }} :
                            </v-col>
                            <v-col cols="7">
                              {{ item.raw?.phone }}
                            </v-col>
                          </v-row>
                          <v-row dense>
                            <v-col
                              cols="5"
                              sm="2"
                              md="2"
                              lg="2"
                              class="font-weight-black"
                              >{{ wordList.lbl_address }} :
                            </v-col>
                            <v-col cols="7">
                              {{ item.raw?.address1 }}{{ item.raw?.address2
                              }}{{ item.raw?.address3 }}
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-center pb-3">
                          <v-btn
                            variant="flat"
                            :disabled="item.raw?.is_deliverable === 0"
                            color="primary"
                            class="btn_width_2 mb-3"
                            @click="onClickDeliveryRequestByUser(item.raw)"
                          >
                            <v-icon>mdi-playlist-edit</v-icon>
                            <span v-if="item.raw?.is_deliverable === 0">
                              {{ wordList.lbl_not_deliverable }}
                            </span>
                            <span v-else>
                              {{ wordList.btn_select_member_regist }}
                            </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                      <!-- 戻るボタン -->
                      <div class="d-flex justify-center">
                        <v-btn
                          variant="flat"
                          color="return"
                          class="btn_width_1 my-3"
                          @click="dialog = false"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                          {{ wordList.btn_return }}</v-btn
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-data-iterator>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-dialog>
            <!-- } 会員登録情報確認ダイアログ -->
            <!-- { ダイアログ -->
            <AlertDialog
              v-model="messagedialog"
              :title="wordList.lbl_delivery_regist"
              :message="message"
              type="info"
            />
            <!-- } ダイアログ -->
          </v-card>
      </v-tabs-window-item>
      <!-- } 定期配送登録タブ -->
      <!-- 定期配送一覧タブ -->
      <v-tabs-window-item :value="1">
        <v-card flat class="mt-6">
            <!-- 検索条件入力 { -->
            <v-expansion-panels v-model="panel" flat multiple class="br_1">
              <v-expansion-panel>
                <v-expansion-panel-title
                  class="py-0 font-weight-bold bk_gray_3"
                >
                  {{ wordList.lbl_search }}
                </v-expansion-panel-title>
                <v-expansion-panel-text class="bk_gray_3 pt-0">
                  <v-divider />
                  <Form v-slot="{ meta }">
                    <v-card class="bk_gray_3" flat>
                      <v-card-text class="pt-9">
                        <v-row>
                          <!-- 会員番号 -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="searchConditionMemberId"
                              :name="wordList.lbl_member_id"
                              rules="numeric|max:100"
                            >
                              <v-text-field
                                v-bind="componentField"
                                :label="wordList.lbl_member_id"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                              ></v-text-field>
                            </Field>
                          </v-col>
                          <!-- お名前(漢字・かな) -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ componentField, errors }"
                              v-model="searchConditionName"
                              :name="wordList.lbl_name_kanji_kana"
                              rules="max:100"
                            >
                              <v-text-field
                                v-bind="componentField"
                                :label="wordList.lbl_name_kanji_kana"
                                bg-color="#fff"
                                density="compact"
                                variant="outlined"
                                clearable
                                :error-messages="errors"
                              ></v-text-field>
                            </Field>
                          </v-col>
                          <!-- 配送エリア -->
                          <v-col cols="12" sm="6" md="4" class="py-0">
                            <Field
                              v-slot="{ errors }"
                              :name="wordList.lbl_delivery_area_name"
                              rules="max:100"
                            >
                              <v-autocomplete
                                v-model="areaSelectValues"
                                density="compact"
                                :items="areaListItems"
                                item-title="area_name"
                                item-value="area_code"
                                :label="wordList.lbl_delivery_area_name"
                                :placeholder="wordList.plc_selectbox"
                                :no-data-text="wordList.lbl_no_data_text"
                                :error-messages="errors"
                                return-object
                                variant="outlined"
                                bg-color="#fff"
                              ></v-autocomplete>
                            </Field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- 絞り込み検索ボタン -->
                        <v-btn
                          variant="flat"
                          color="primary"
                          class="px-16 mt-6"
                          :disabled="!meta.valid"
                          @click="onClickSearch"
                        >
                          <v-icon>mdi-magnify</v-icon>
                          {{ wordList.lbl_search }}
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </Form>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- 検索条件入力 } -->
            <!-- 一覧表示  { -->
            <v-card flat width="100%">
              <v-data-table-server
                v-model="selectListCheckbox"
                v-model:options="listOptions"
                item-key="regular_delivery_no"
                item-value="regular_delivery_no"
                :items-per-page="listOptions.itemsPerPage"
                :items="listDataArray"
                :items-length="listDataTotalCount"
                :loading="listLoading"
                hide-default-footer
                show-select
                return-object
                :headers="tableHeaders"
                :no-data-text="wordList.lbl_no_data_text"
                :row-props="getRowProps"
              >
                <template #top>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex justify-space-between mt-9 mb-5"
                    >
                      <div class="d-flex align-center">
                        <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                        ><span class="pl-1"> {{ displayPagingRange }} </span>
                        <v-pagination
                          v-model="listOptions.page"
                          :length="pageCount"
                          :total-visible="7"
                          variant="elevated"
                          density="comfortable"
                        >
                        </v-pagination>
                      </div>
                      <div v-if="!isXs">
                        <v-menu open-on-hover location="bottom">
                          <template #activator="{ props }">
                            <v-btn
                              variant="text"
                              color="black"
                              v-bind="props"
                              class="pr-0 pl-2"
                            >
                              アクション
                              <v-icon>mdi-cog</v-icon>
                            </v-btn>
                          </template>
                          <v-list width="250" class="pl-5">
                            <v-list-item-title
                              style="cursor: pointer"
                              @click="onClickCheckDelete"
                            >
                              <v-icon class="mr-2">mdi-delete</v-icon
                              >{{ wordList.btn_delete_all }}
                            </v-list-item-title>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <template #[`item.week`]="{ item }">
                  <span
                    v-if="item.mon_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >月
                  </span>
                  <span v-if="item.mon_to_deliver == 1" class="text-black"
                    >月
                  </span>
                  <span
                    v-if="item.tue_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >火
                  </span>
                  <span v-if="item.tue_to_deliver == 1" class="text-black"
                    >火
                  </span>
                  <span
                    v-if="item.wed_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >水
                  </span>
                  <span v-if="item.wed_to_deliver == 1" class="text-black"
                    >水
                  </span>
                  <span
                    v-if="item.thu_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >木
                  </span>
                  <span v-if="item.thu_to_deliver == 1" class="text-black"
                    >木
                  </span>
                  <span
                    v-if="item.fri_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >金
                  </span>
                  <span v-if="item.fri_to_deliver == 1" class="text-black"
                    >金
                  </span>
                  <span
                    v-if="item.sat_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >土
                  </span>
                  <span v-if="item.sat_to_deliver == 1" class="text-black"
                    >土
                  </span>
                  <span
                    v-if="item.sun_to_deliver == 0"
                    class="text-grey-lighten-2"
                    >日</span
                  >
                  <span v-if="item.sun_to_deliver == 1" class="text-black"
                    >日</span
                  >
                </template>
                <template #[`item.actions`]="{ item }">
                  <div>
                    <v-btn
                      variant="outlined"
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      icon
                      rounded="xl"
                      @click="onClickEdit(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      variant="outlined"
                      color="red"
                      class="my-2 ml-2 mr-0"
                      size="x-small"
                      icon
                      rounded="xl"
                      @click="onClickDelete(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table-server>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-card>
            <!-- 一括削除確認ダイアログ {-->
            <v-dialog
              v-model="confirmDeleteDialog"
              content-class="dialog_width_1"
              :lock-scroll="false"
              scrollable
            >
              <v-data-iterator
                :items="selectedListItems"
                item-key="regular_delivery_no"
                hide-default-footer
                :items-per-page="selectedListItems.length"
              >
                <template #default="{ items }">
                  <v-card class="d-flex flex-column rounded-t rounded-b-0" style="max-height: 80vh">
                    <v-card-title class="bg-red mb-5" style="color: white">
                      {{ wordList.lbl_delete_all_confirm }}
                    </v-card-title>
                    <v-card-text class="font-weight-black">
                      {{ selectedListItems.length }}
                      {{ wordList.lbl_delete_all_confirm_msg }}
                    </v-card-text>
                    <v-card-text class="flex-grow-1 overflow-y-auto">
                      <v-card
                        v-for="item in items"
                        :key="item.raw?.regular_delivery_no ?? item.id"
                        flat
                        border
                        class="mb-5"
                      >
                        <v-divider class="mx-4"></v-divider>
                        <v-list density="compact">
                          <!-- 会員番号 -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end">
                                  {{ wordList.lbl_member_id }}:
                                </v-row>
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.memberId }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 会員名 -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end">
                                  {{ wordList.lbl_name }}:
                                </v-row>
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.memberName }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 配達曜日 -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end">
                                  {{ wordList.lbl_delivery_week_list }}:
                                </v-row>
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                <span v-if="item.raw?.mon_to_deliver === 1"
                                  >月&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.tue_to_deliver === 1"
                                  >火&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.wed_to_deliver === 1"
                                  >水&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.thu_to_deliver === 1"
                                  >木&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.fri_to_deliver === 1"
                                  >金&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.sat_to_deliver === 1"
                                  >土&nbsp;&nbsp;</span
                                >
                                <span v-if="item.raw?.sun_to_deliver === 1"
                                  >日</span
                                >
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 便名 -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end">
                                  {{ wordList.lbl_delivery_id_list }}:
                                </v-row>
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.deliveryIdName }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!-- 配達時間 -->
                          <v-list-item>
                            <v-row dense>
                              <v-col
                                cols="5"
                                sm="4"
                                md="4"
                                lg="4"
                                class="font-weight-black"
                              >
                                <v-row dense class="py-2 justify-end">
                                  {{ wordList.lbl_delivery_time }}:
                                </v-row>
                              </v-col>
                              <v-col cols="7" class="d-flex align-center">
                                {{ item.raw?.deliveryTime }}
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </template>
                <template #footer>
                  <v-card flat class="py-4 rounded-b rounded-t-0">
                    <v-row justify="center">
                      <!-- 戻るボタン -->
                      <v-btn
                        variant="flat"
                        color="return"
                        class="px-16 mx-2 my-2"
                        width="168px"
                        @click="confirmDeleteDialog = false"
                      >
                        <v-icon>mdi-arrow-left</v-icon>
                        {{ wordList.btn_return }}</v-btn
                      >
                      <v-btn
                        variant="outlined"
                        class="bg-red-darken-1 mx-2 my-2"
                        color="white"
                        width="168px"
                        @click="onClickCheckDeleteComplete"
                        >{{ wordList.btn_delete_all }}
                      </v-btn>
                    </v-row>
                  </v-card>
                </template>
              </v-data-iterator>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-dialog>
            <!-- } 削除確認ダイアログ -->
          </v-card>
      </v-tabs-window-item>
      <!-- } 定期配送一覧タブ -->
    </v-tabs-window>
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unused-vars */
import { computed, onMounted, onBeforeUnmount } from "vue";
import { useDisplay } from "vuetify";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max, length, numeric } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

import AlertDialog from "@/components/AlertDialog.vue";

import { useRegularDeliveryUiState } from "./composables/useRegularDeliveryUiState";
import { useRegularDeliverySearchForm } from "./composables/useRegularDeliverySearchForm";
import { useRegularDeliveryTable } from "./composables/useRegularDeliveryTable";
import { useRegularDeliveryAvailability } from "./composables/useRegularDeliveryAvailability";
import { useRegularDeliveryInit } from "./composables/useRegularDeliveryInit";
import { useRegularDeliveryRegistForm } from "./composables/useRegularDeliveryRegistForm";
import { useRegularDeliveryListQuery } from "./composables/useRegularDeliveryListQuery";
import { useRegularDeliveryActions } from "./composables/useRegularDeliveryActions";

defineRule("required", required);
defineRule("max", max);
defineRule("length", length);
defineRule("numeric", numeric);
configure({
  generateMessage: localize({
    ja,
  }),
});
setLocale("ja");

const { xs } = useDisplay();
const isXs = computed(() => xs.value);

// -------------------------------
// UI状態管理
// -------------------------------
const {
  model,
  mode,
  errdialog,
  errMessage,
  processFlag,
  panel,
  overlay,
  confirmDeleteDialog,
  dialog,
  messagedialog,
  message,
  uploadDialog,
  btnDisabled,
  shopSelectFromValues,
  shopSelectToValues,
  onClickRegistTab,
  onClickListTab,
  openSearchPanel,
  closeSearchPanel,
} = useRegularDeliveryUiState();

// -------------------------------
// 検索フォーム
// -------------------------------
const {
  searchConditionMemberId,
  searchConditionName,
  searchConditionAreaCode,
  areaListItems,
  areaSelectValues,
  syncSearchAreaCode,
} = useRegularDeliverySearchForm();

// -------------------------------
// テーブル管理
// -------------------------------
const {
  tableHeaders,
  listLoading,
  listOptions,
  listDataArray,
  deleteItem,
  listDataTotalCount,
  pageCount,
  displayPagingRange,
  selectListCheckbox,
  selectedListItems,
  getRowProps,
  updateDisplayPagingRange,
} = useRegularDeliveryTable();

// -------------------------------
// 配達便データ
// -------------------------------
const {
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  deliveryAvailabilityStore,
  onDeliveryAvailabilityClick,
  showDeliveryAvailability,
  getDeliveryAvailable,
  formatDate,
} = useRegularDeliveryAvailability({
  btnDisabled,
});

// -------------------------------
// 初期化（共有ref群を保持）
// -------------------------------
const {
  wordList,
  isWordListReady,
  house_card_display,
  is_hide_other_shop_members,
  chainListItems,
  chainSelectValues,
  shopListFromItems,
  shopListToItems,
  prefListItems,
  items,
  tab,
  runInitialLoad,
} = useRegularDeliveryInit({
  overlay,
  errdialog,
  errMessage,
  areaListItems,
  shopSelectFromValues,
  shopSelectToValues,
});

// -------------------------------
// 登録フォーム
// -------------------------------
const {
  btnNonMemberToggle,
  prefSelectValue,
  phone_number,
  user_name,
  house_card,
  userErrorMessage,
  zip_code,
  errorZipCode,
  errorPrefSelect,
  listMemberResult,
  memberData,
  onClickToggleZip,
  onClickTogglePref,
  onZipCodeInput,
  onPrefSelectInput,
  onClickDeliveryRequestAndNewMember,
  onClickDeliveryRequest,
  onClickDeliveryRequestByUser,
  onClickDeliveryRequestByNumberId,
} = useRegularDeliveryRegistForm({
  dialog,
  messagedialog,
  message,
  wordList,
  deliveryAvailabilityStore,
  house_card_display,
  is_hide_other_shop_members,
  prefListItems,
});

// -------------------------------
// 一覧クエリ
// -------------------------------
const {
  shopListInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  operationInput,
  shopData,
  shopData_from_name,
  shopData_from_address,
  shopData_from_zip_code,
  shopData_to_name,
  shopData_to_address,
  getShopData,
  GetAreaData,
  chkDeliveryId,
  onClickSearch,
  searchQuery,
  isUpdateModeBack,
} = useRegularDeliveryListQuery({
  searchConditionMemberId,
  searchConditionName,
  searchConditionAreaCode,
  listOptions,
  listLoading,
  listDataArray,
  listDataTotalCount,
  selectListCheckbox,
  errdialog,
  errMessage,
  areaListItems,
  chainSelectValues,
  shopSelectFromValues,
  syncSearchAreaCode,
  updateDisplayPagingRange,
});

// -------------------------------
// 一覧行アクション
// -------------------------------
const {
  onClickEdit,
  onClickDelete,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
} = useRegularDeliveryActions({
  searchConditionMemberId,
  searchConditionName,
  searchConditionAreaCode,
  selectListCheckbox,
  confirmDeleteDialog,
  overlay,
  errdialog,
  errMessage,
  deliveryAvailabilityStore,
  searchQuery,
});

let interval: ReturnType<typeof setInterval> | null = null;

////////////////////////////////////////////////////////////////////////////////
// 初期画面
////////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
  await runInitialLoad({
    onClickListTab,
    onClickSearch,
    showDeliveryAvailability,
  });
});

/**
 * 初期表示処理
 */
onBeforeUnmount(() => {
  if (interval !== null) {
    clearInterval(interval);
  }
});
</script>

<style scoped></style>
